export default __webpack_public_path__ + "maps-examples-shape-collection-960-d92174a41aea6cc2553c26ce4e38dfc2.webp";